<template>
  <article class="portal-surcharge-table">
    <h3 class="portal-surcharge-table__title">
      {{ $t("portalHome.analytics.surchargeTable.title") }}
    </h3>

    <Loader v-if="loading" :show="true" />

    <template v-else>
      <div class="portal-surcharge-table__wrap">
        <table class="portal-surcharge-table__table">
          <thead>
            <tr>
              <th class="portal-surcharge-table__th portal-surcharge-table__th--brand">
                {{ $t("portalHome.analytics.surchargeTable.diameterHeader") }}
              </th>
              <th
                v-for="column in columns"
                :key="column.id"
                class="portal-surcharge-table__th portal-surcharge-table__th--value"
              >
                {{ columnLabel(column) }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, rowIndex) in rows"
              :key="row.id"
              class="portal-surcharge-table__row"
              :class="{ 'portal-surcharge-table__row--alt': rowIndex % 2 === 0 }"
            >
              <td class="portal-surcharge-table__td portal-surcharge-table__td--brand">
                <img
                  v-if="row.brand === 'bridgestone'"
                  :src="bridgestoneLogoSrc"
                  alt="Bridgestone"
                  width="195"
                  height="24"
                  class="portal-surcharge-table__logo portal-surcharge-table__logo--bs"
                />
                <img
                  v-else
                  :src="firestoneLogoSrc"
                  alt="Firestone"
                  width="195"
                  height="34"
                  class="portal-surcharge-table__logo portal-surcharge-table__logo--fs"
                />
              </td>
              <td
                v-for="(points, colIndex) in row.points"
                :key="`${row.id}-${colIndex}`"
                class="portal-surcharge-table__td portal-surcharge-table__td--value"
              >
                {{ points }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <footer class="portal-surcharge-table__footer">
        <div class="portal-surcharge-table__notes">
          <p>{{ $t("portalHome.analytics.surchargeTable.note1") }}</p>
          <p>{{ $t("portalHome.analytics.surchargeTable.note2") }}</p>
        </div>
        <button type="button" class="portal-surcharge-table__rules-btn">
          {{ $t("portalHome.analytics.surchargeTable.rulesButton") }}
        </button>
      </footer>
    </template>
  </article>
</template>

<script setup>
import { defineProps } from "vue";
import { useI18n } from "vue-i18n";
import bridgestoneLogoSrc from "@/assets/img/portal-home/logo.png";
import firestoneLogoSrc from "@/assets/img/portal-home/firestone.png";
import Loader from "@/components/General/Loader/index.vue";

const { t } = useI18n();

function columnLabel(column) {
  const inch = `${column.rimSize}"`;

  if (column.andMore) {
    return `${inch} ${t("portalHome.analytics.surchargeTable.andMore")}`;
  }

  return inch;
}

defineProps({
  columns: {
    type: Array,
    default: () => [],
  },
  rows: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped lang="scss">
@import "@/styles/portal-home/portal-surcharge-table";
</style>
